import { render, staticRenderFns } from "./ReporteSuraSGMM.vue?vue&type=template&id=1469751e"
import script from "./ReporteSuraSGMM.vue?vue&type=script&lang=js"
export * from "./ReporteSuraSGMM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports